


















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { SkillModel, StatusModel, JobPointFormula } from '@/model/charactersheets';
import Item from './item.vue';
type Formula = {
  value: JobPointFormula;
  text: string;
};
@Component({
  components: { Item },
})
export default class Presentational extends Vue {
  private formulas: Formula[] = [
    {
      value: 0,
      text: '(EDU × 4)',
    },
    {
      value: 1,
      text: '(EDU × 2) + (DEX × 2)',
    },
    {
      value: 2,
      text: '(EDU × 2) + (STR × 2)',
    },
    {
      value: 3,
      text: '(EDU × 2) + (POW × 2)',
    },
    {
      value: 4,
      text: '(EDU × 2) + (APP × 2)',
    },
  ];
  @Prop() public gamesystem!: number;
  @Prop() public skills!: SkillModel[];
  @Prop() public statuses!: StatusModel;
  @Prop() public jobPointFormula!: JobPointFormula;

  @Emit() public update(value: SkillModel[]) {}
  @Emit() public updateformula(value: JobPointFormula) {}
  @Emit() public delete(value: SkillModel[]) {}

  private get values(): SkillModel[] {
    return this.skills;
  }
  private get jobpoint(): number {
    const basePoint = (this.statuses.edu.default + this.statuses.edu.correction) * 10;
    switch (this.jobPointFormula) {
      case 0:
        return basePoint + (this.statuses.edu.default + this.statuses.edu.correction) * 10;
      case 1:
        return basePoint + (this.statuses.dex.default + this.statuses.dex.correction) * 10;
      case 2:
        return basePoint + (this.statuses.str.default + this.statuses.str.correction) * 10;
      case 3:
        return basePoint + (this.statuses.pow.default + this.statuses.pow.correction) * 10;
      case 4:
        return basePoint + (this.statuses.app.default + this.statuses.app.correction) * 10;
      default:
        return basePoint + (this.statuses.edu.default + this.statuses.edu.correction) * 10;
        break;
    }
  }
  private get interestpoint(): number {
    return (this.statuses.int.default + this.statuses.int.correction) * 10;
  }
  private get jobusepoint(): number {
    let jobTotal = 0;
    this.skills.forEach(element => {
      jobTotal += element.jobpoint;
    });
    return jobTotal;
  }
  private get interestusepoint(): number {
    let interestTotal = 0;
    this.skills.forEach(element => {
      interestTotal += element.interestpoint;
    });
    return interestTotal;
  }
  private get selected(): JobPointFormula {
    return this.jobPointFormula;
  }

  private set selected(payload: JobPointFormula) {
    this.updateformula(payload);
  }

  public updateSkill(skill: SkillModel, index: number) {
    const newValue = [...this.skills.slice(0, index), skill, ...this.skills.slice(index + 1)];
    this.update(newValue);
  }
  public deleteSkill(index: number) {
    const newValue = [...this.skills.slice(0, index), ...this.skills.slice(index + 1)];
    this.delete(newValue);
  }
}
